import { useEffect, useState } from 'react';
import '../css/VisualizarPilotosNoMapa.css';
import Cookies from 'js-cookie';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import { buscarPilotosDeMototaxiByPonto } from '../servicos/listagemServico';

// Ícone moto (coloque a imagem em public/imagens/moto-icon.png)
const iconeMoto = new L.Icon({
  iconUrl: '/imagens/icones/moto-verde-esportiva.png',
  iconSize: [40, 40],
  iconAnchor: [20, 40],
  popupAnchor: [0, -40]
});

function VisualizarPilotosNoMapa() {

  const [pilotos, setPilotos] = useState([]);
  const [pilotoSelecionado, setPilotoSelecionado] = useState(null);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [posicao, setPosicao] = useState(null);

  useEffect(() => {
    const carregarPilotos = async () => {
      console.log('Entrou em carregarPilotos, em VisualizarPilotosNoMapa...');
      
      try {
        const cookies = Cookies.get();
        const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

        console.log('dadosCookies: ');
        console.log(dadosCookies);
        
        if (!dadosCookies || !dadosCookies.dadosPontoMototaxi?.id) {
          alert("Erro: dados do ponto não encontrados.");
          return;
        }


        console.log('Localização do Ponto: ');
        console.log(dadosCookies.dadosPontoMototaxi.latitude);
        console.log(dadosCookies.dadosPontoMototaxi.longitude);

        if (!dadosCookies || !dadosCookies.dadosPontoMototaxi?.id) {
          alert("Erro: dados do ponto não encontrados.");
          return;
        }

        const resposta = await buscarPilotosDeMototaxiByPonto(dadosCookies);
        setPilotos(resposta.pilotos || []);

        const latPonto = parseFloat(dadosCookies.dadosPontoMototaxi.latitude);
        const lngPonto = parseFloat(dadosCookies.dadosPontoMototaxi.longitude);
        if (!isNaN(latPonto) && !isNaN(lngPonto)) {
          console.log("Centralizando no ponto do mototáxi:", latPonto, lngPonto);
          setPosicao([latPonto, lngPonto]);
        }

      } catch (erro) {
        console.error("Erro ao buscar pilotos:", erro);
        alert("Erro ao buscar pilotos cadastrados.");
      }
    };

    carregarPilotos();

    const intervalo = setInterval(() => {
      carregarPilotos();
    }, 60000); // 60 segundos

    return () => clearInterval(intervalo);

  }, []);

  const abrirModal = (piloto) => {
    setPilotoSelecionado(piloto);
    setMostrarModal(true);
  };

  const fecharModal = () => {
    setMostrarModal(false);
    setPilotoSelecionado(null);
  };

  return (
    <div style={{ height: 'calc(100vh - 110px)' }}>
      {posicao ? (
        <MapContainer center={posicao} zoom={10} style={{ flex: 1, height: '100%', width: '100%' }}>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="© OpenStreetMap contributors"
          />

          {pilotos.map((p) => {
            const piloto = p.objPiloto;
            const usuario = p.objUser;
            const status = p.objStatusPiloto;

            return (
              <Marker
                key={piloto.id}
                position={[piloto.latitude, piloto.longitude]}
                icon={iconeMoto}
                // eventHandlers={{
                //   click: () => abrirModal({ ...p, usuario, piloto, status })
                // }}
              >
                <Popup>
                  <div style={{ textAlign: 'center' }}>
                    <strong>{usuario.name}</strong><br />
                    <button 
                      className="btn btn-sm btn-primary mt-2"
                      onClick={() => abrirModal({ ...p, usuario, piloto, status })}
                    >
                      Ver detalhes
                    </button>
                  </div>
                </Popup>
              </Marker>
            );
          })}
        </MapContainer>
      ) : null }

      {/* Modal feito só com Bootstrap CSS */}
      {mostrarModal && pilotoSelecionado && (

        <div className="modal fade show d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Detalhes do Piloto</h5>
                <button type="button" className="btn-close" onClick={fecharModal}></button>
              </div>

              <div className="modal-body">
                <ul className="list-group list-group-flush mb-3">
                  <li className="list-group-item">
                    <strong>Nome:</strong> {pilotoSelecionado.objUser.name}
                  </li>
                  <li className="list-group-item">
                    <strong>Email:</strong> {pilotoSelecionado.objUser.email}
                  </li>
                  <li className="list-group-item">
                    <strong>Telefone:</strong> {pilotoSelecionado.objPiloto.numero_celular_com_ddd}
                  </li>
                  <li className="list-group-item">
                    <strong>Status:</strong> 
                    <span className="badge bg-info ms-2">
                      {pilotoSelecionado.objStatusPiloto?.nome}
                    </span>
                  </li>
                  <li className="list-group-item">
                    <strong>Latitude:</strong> {pilotoSelecionado.objPiloto.latitude}
                  </li>
                  <li className="list-group-item">
                    <strong>Longitude:</strong> {pilotoSelecionado.objPiloto.longitude}
                  </li>
                  <li className="list-group-item">
                    <strong>Início vigência:</strong> {pilotoSelecionado.data_inicio_vigencia}
                  </li>
                  <li className="list-group-item">
                    <strong>Fim vigência:</strong> {pilotoSelecionado.data_fim_vigencia}
                  </li>
                </ul>

                <h6>Serviços Atendidos</h6>
                <ul className="list-group">
                  {pilotoSelecionado.arrayServicosAtendidosPeloPiloto.map((servico, i) => (
                    <li key={i} className="list-group-item">
                      {servico.nome}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={fecharModal}>
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default VisualizarPilotosNoMapa;


// função para centralizar
function CentralizarNoPonto({ ponto }) {
  const map = useMap();

  useEffect(() => {
    if (ponto && ponto.lat && ponto.lng) {
      map.setView([ponto.lat, ponto.lng], 15); // centraliza só uma vez
    }
  }, [ponto, map]);

  return null;
}